export class Model<K> {
  with = (data: Partial<K>): this => {
    Object.assign(this, data)

    return this
  }
}
